module.exports = __webpack_public_path__ + "static/media/Lomowebpixel-01.9d3a0d4c.svg";